import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import { CardActions } from '@material-ui/core';
import Info from '@material-ui/icons/Info';

import PlanCard from '../plans/PlanCard';
import ConfirmButton from '../ConfirmButton';
import DenyButton from '../DenyButton';
import CustomSwitch from '../CustomSwitch';
import { PERIODICITY } from '../../actions/products';

/**
 * Change subscription plan component
 * Display a grid of other available plans for a product
 */

const styles = theme => ({
    colorDefault: {
        color: '#797979'
    },
    form: {
      backgroundColor: theme.form.backgroundColor
    },
    spacing: {
      marginLeft: 40,
    },
    actions: {
      justifyContent: 'center',
    },
    subTitle: {
        marginLeft: 16,
        marginBottom: 14,
    },
    button: {
        flex: 1,
        marginBottom: 16,
        marginLeft:32,
        marginRight: 32,
        borderRadius: 24,
        backgroundColor: '#3E82F7',
        boxShadow: 'none'
    },
    dialogIcon: {
        marginRight: 12,
        verticalAlign: 'middle',   
    },
    dialogSecodaryText: {
        marginTop: 16,
    }
  })

class ChangeSubscriptionPlan extends Component {

    render() {
        const {
            subscription,
            otherPlans,
            classes,
            handlePlanChangeAndPaymentInfo,
            handleSwitchOnPeriod,
            planTargetPeriodicity,
            switchOnMonthlyPlans,
            isBothPeriodicityAvailable,
        } = this.props;

        let prefilteredPlans = [];
        if (isBothPeriodicityAvailable) {
            prefilteredPlans =  otherPlans.filter(plan => plan.isFree || (plan.periodicity === planTargetPeriodicity && plan.name !== subscription.plan.name));
        } else {
            prefilteredPlans = otherPlans;
        }

        return (
            <div>
                <Typography variant="h5" className={classNames(classes.colorDefault, classes.subTitle)} >
                    {otherPlans.length > 1 ?
                        <FormattedMessage id='update.subscription.page.other.plan.label.plural' />
                        :
                        <FormattedMessage id='update.subscription.page.other.plan.label' />
                    }        
                </Typography> 
                <Grid container spacing={24} style={{marginLeft:4}}>
                    {prefilteredPlans && 
                        prefilteredPlans.map(plan => {
                            const withChargifyRedirection = !(subscription.hasPaymentInfo 
                                || (subscription.status==='active' && !subscription.plan.isFree)
                                || plan.isFree
                                || (subscription.status==='trialing' && plan.trialDuration >= 1));

                            const isTrialAbort = subscription.status==='trialing' && plan.isFree;

                            const isSwitchingNotAllowed = (plan.isFree && subscription.licencesCount > 1)
                                                            || (!plan.domainInvitationSettings && (subscription.plan.domainInvitationSettings && subscription.domainInvitationsCount > 0));
                            
                            return(
                                <Grid item key={plan.id} sm={12} md={6} lg={4}>
                                    <PlanCard
                                        plan={plan}
                                        actions={
                                            <div>
                                                <CardActions className={classes.actions}>
                                                    {
                                                        isSwitchingNotAllowed ?
                                                        <DenyButton
                                                            className={classes.button}
                                                            variant="contained"
                                                            size="small"
                                                            color="primary"
                                                            title={
                                                                !plan.domainInvitationSettings && (subscription.plan.domainInvitationSettings && subscription.domainInvitationsCount > 0)
                                                                    ? <FormattedMessage id="subscription.domain.info.updatedLicences.notAllowedPlanSwitch.title" />
                                                                    : <FormattedMessage id="subscription.info.updatedLicences.notAllowedPlanSwitch.title" />
                                                            }
                                                            message={
                                                                !plan.domainInvitationSettings && (subscription.plan.domainInvitationSettings && subscription.domainInvitationsCount > 0)
                                                                ?<FormattedMessage 
                                                                    id="subscription.domain.info.updatedLicences.notAllowedPlanSwitch"
                                                                    values={{planName: plan.name}} />
                                                                :<FormattedMessage 
                                                                    id="subscription.info.updatedLicences.notAllowedPlanSwitch"
                                                                    values={{planName: plan.name}} />
                                                            }
                                                            disabled={!!subscription.updatingOn}
                                                        >
                                                            <FormattedMessage id='plan.button.choose' /> 
                                                        </DenyButton>
                                                        :
                                                        <ConfirmButton
                                                            className={classes.button}
                                                            variant="contained"
                                                            size="small"
                                                            color="primary"
                                                            title= {
                                                                <FormattedMessage id="subscription.confirmation.plan.update.title" />
                                                            }
                                                            message={
                                                                withChargifyRedirection ? 
                                                                <FormattedMessage id="subscription.confirmation.chargify.redirection" />
                                                                :
                                                                <div>
                                                                    {
                                                                        isTrialAbort ? 
                                                                        <div style={{whiteSpace:'pre'}}>
                                                                            <FormattedMessage 
                                                                                id="subscription.confirmation.endOfTrial.info" 
                                                                                values={{subscriptionPlanName: subscription.plan.name, planName: plan.name}} />
                                                                        </div>
                                                                        : 
                                                                        <div>
                                                                            <FormattedMessage id="subscription.confirmation.plan.update" />  
                                                                            <div className={classes.dialogSecodaryText}>
                                                                                <Info className={classes.dialogIcon} color='primary'/>     
                                                                                <FormattedMessage id="subscription.confirmation.plan.update.info" /> 
                                                                            </div>    
                                                                        </div>
                                                                    } 
                                                                </div>
                                                            }
                                                            onClick={() => handlePlanChangeAndPaymentInfo(plan)}
                                                            disabled={!!subscription.updatingOn}
                                                            working={subscription.updatingOn && subscription.updatingOn === plan.id}
                                                        >  
                                                            <FormattedMessage id='plan.button.choose' /> 
                                                        </ConfirmButton>
                                                    }
                                                </CardActions>
                                            </div>
                                        }
                                    />
                                </Grid>
                            )
                        })    
                    } 
                </Grid>
                {isBothPeriodicityAvailable &&
                    <Grid container>
                        <Grid item key="switch" sm={12} md={6*Math.min(2, prefilteredPlans.length)} lg={4*prefilteredPlans.length} >
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}} >
                                <Typography variant="button" className={switchOnMonthlyPlans ? classes.focus : classes.unFocused}>
                                    <FormattedMessage id='product.switcher.monthly.text'/>
                                </Typography>
                                <CustomSwitch
                                    checked={!switchOnMonthlyPlans}
                                    onChange={switchOnMonthlyPlans ? () => handleSwitchOnPeriod(PERIODICITY.YEARLY) : () => handleSwitchOnPeriod(PERIODICITY.MONTHLY)} 
                                    value="MonthlyYearlySwitcher"
                                    inputProps={{ 'aria-label': 'MonthlyYearlySwitcher' }}
                                />
                                <Typography variant="button" className={switchOnMonthlyPlans ? classes.unFocused : classes.focus}> 
                                    <FormattedMessage id='product.switcher.yearly.text'/>
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                }
            </div>
        )
    }
}

ChangeSubscriptionPlan.propTypes = {
    classes: PropTypes.object.isRequired,
    handlePlanChangeAndPaymentInfo: PropTypes.func.isRequired,
}

export default withStyles(styles)(
    ChangeSubscriptionPlan
);


// WEBPACK FOOTER //
// ./src/components/plans/ChangeSubscriptionPlan.js